import { Component, Inject, inject, Optional } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { EmployeeService } from '@lmc-app/core/services/employee.service';
import { genValidPass } from '@lmc-app/utils/password-functions'
import { SnackbarConstants } from '@lmc-app/shared/constants/snackbar.constant';
import { Loading } from '../../../applications/loading';

@Component({
  selector: 'app-reset-password-modal',
  templateUrl: './reset-password-modal.component.html',
  styleUrls: ['./reset-password-modal.component.scss']
})
export class ResetPasswordModalComponent{

  private readonly _bottomSheet = inject(MatBottomSheet);
  private readonly _snackBar = inject(MatSnackBar);
  private readonly passwordRe = /(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[`~!@#$%\^&*\(\)\-_\+\=\[\]\{\}\\\|;:\'",\.\<\>?\/]).*?/;

  resetPasswordForm = new FormGroup({
      password: new FormControl(null, [
        Validators.required,
        Validators.minLength(12),
        Validators.maxLength(45),
        Validators.pattern(this.passwordRe),
      ]),
  });
  
  constructor(
    private employeeService: EmployeeService,
    public dialogRef: MatDialogRef<ResetPasswordModalComponent>,
		@Optional() @Inject(MAT_DIALOG_DATA) public data: any
  ){}

  ngOnInit() {
		this.initialData();
  }

  initialData() {
		this.resetPasswordForm.controls.password.setValue(genValidPass(12, true, true, true, this.passwordRe));
  }

	resetPassword(){
    this._bottomSheet.open(Loading, {
        disableClose: true,
        data: { message: 'Resetting Password' },
      });
      const employee = this.convertFormToJson();
      this.employeeService.resetPassword(employee).subscribe({
        next: (res) => {
          this._snackBar.open(
            `Password for ${res.full_name} is reset.`,
            SnackbarConstants.ACTION_DISMISS,
            SnackbarConstants.DURATION_DISMISS_SHORT
          );
          this._bottomSheet.dismiss();
          this.closeModal();
        },
        error: (error) => {
          this._bottomSheet.dismiss();
          console.error(error);
          this._snackBar.open(
            (error.error && (error.error.message && (error.error.message.name || error.error.message))) || 'Error reseting password.',
            SnackbarConstants.ACTION_DISMISS,
            SnackbarConstants.DURATION_DISMISS_SHORT
          );
        },
      });
	}

  closeModal(){
    this.dialogRef.close(false);
  }

  convertFormToJson() {
		const employee = this.resetPasswordForm.getRawValue();
		employee["employee_id"] = this.data.employee_id;
		return employee;
	}
}
